import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import { Router } from '@angular/router';
import { CompleteFunctionService } from '../../../shared/utils/complete-function.service';
import { StorageService } from '../../../shared/security/StorageService';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { Subscription } from 'rxjs';
import { SeverEmploymentService } from '../sever-employment.service';
import { EntityLicenseModel } from '../../../model/entityLicenseModel';
import { MessageModel } from '../../../model/messageModel';
import { CompleteFunctionRequestModel } from '../../../model/completeFunctionRequestModel';
import { CompleteFunctionResponseModel } from '../../../model/completeFunctionResponseModel';
import { WorkflowModel } from '../../../model/workflowModel';
import * as $ from 'jquery';
import { SeverEmploymentResponseModel } from '../../../model/severEmploymentResponseModel';

//review step
@Component({
  selector: 'app-sever-review-employment',
  templateUrl: './sever-employment-review.component.html',
  styleUrls: ['./sever-employment-review.component.css']
})
export class SeverEmploymentReview implements OnInit,OnDestroy {
  startFunction: StartFunctionResponseModel;

  completeFunctionRequest: CompleteFunctionRequestModel;
  completeFunctionResponse: CompleteFunctionResponseModel;

  employmentInfo: EntityLicenseModel;
  agree: boolean = false;
  userMessages: Array<MessageModel> = [];
  workflow:WorkflowModel;
  severEmploymentResponse: SeverEmploymentResponseModel=null;

 
  severEmploymentInfoSubscription: Subscription;
  severemploymentAgreementSubsription: Subscription;
  severEmploymentResponseSubsription: Subscription;


  constructor(private currentPageWatcher: CurrentPageWatcherService,
    private startFunctionService: StartFunctionService,
    private spinner: SpinnerService,
    private router: Router,
    private completeFunctionService: CompleteFunctionService,
    private storageService: StorageService,
    private severEmploymentService:SeverEmploymentService ) {
      
      this.startFunction = this.storageService.getStartFunctionData();
      this.workflow = this.startFunction.Workflow;

      this.severEmploymentResponseSubsription = this.severEmploymentService.getNotifySelectedEmployer().subscribe(data => {
        this.severEmploymentResponse = data;
        console.log("Sever Employment Response : " + this.severEmploymentResponse);
      });
      this.severEmploymentInfoSubscription = this.severEmploymentService.getNotifySeverEmploymentInformation().subscribe(data => {
        this.employmentInfo = data;
        console.log("Employment Info in Confirmation",data);
      });
  
      this.severemploymentAgreementSubsription = this.severEmploymentService.getNotifySeverAgreement().subscribe(data => {
        this.agree = data;
      });
  
     }

  ngOnInit() {
    if (this.severEmploymentResponse!= null && this.severEmploymentResponse!= undefined)
    this.workflow = this.severEmploymentResponse.Workflow;
  else
    this.workflow = this.startFunction.Workflow;

    console.log("this.workflow from review : ",this.workflow);
  }

  completeFunction() {
    this.currentPageWatcher.sendUserMessages(null);
    this.completeFunctionRequest = new CompleteFunctionRequestModel();
    this.completeFunctionRequest.WorkflowID = this.workflow.WorkflowID;
    this.completeFunctionRequest.CurrentStepIndex = this.workflow.CurrentStepIndex;
    this.completeFunctionRequest.OrderNumber = null;

    if(this.workflow.Fees.length!=0 && this.workflow.Fees!=null){
      this.router.navigate(["/severEmploymentPay"]).then(()=>{
        this.startFunctionService.getNotifyStepInProgress().emit(true);
        this.severEmploymentService.getNotifySelectedEmployer().emit(this.severEmploymentResponse);
        this.severEmploymentService.getNotifySeverEmploymentInformation().emit(this.employmentInfo);
        this.severEmploymentService.getNotifySeverAgreement().emit(this.agree);

      })
    }
    else{
    this.completeFunctionService.completeFunction(this.completeFunctionRequest).subscribe(completeFunctionResp => {
      this.completeFunctionResponse = completeFunctionResp;
      console.log("completeFunctionResp:  ", completeFunctionResp);
      if (completeFunctionResp.UserMessages != undefined) {
        completeFunctionResp.UserMessages.forEach(el => {
            this.userMessages.push(el);
        });
      }
      this.currentPageWatcher.sendUserMessages(this.userMessages);
      //no error 
      if (completeFunctionResp.Summary == 0) {
        this.router.navigate(['/severEmploymentReceipt']).then(() => {
          this.startFunctionService.getNotifyStepInProgress().emit(true);
          this.severEmploymentService.getNotifySelectedEmployer().emit(this.severEmploymentResponse);
          this.severEmploymentService.getNotifyCompleteSeverEmployer().emit(completeFunctionResp);
          this.severEmploymentService.getNotifySeverEmploymentInformation().emit(this.employmentInfo);
          this.severEmploymentService.getNotifySeverAgreement().emit(this.agree);
        });
        this.userMessages = [];
      }
      if (completeFunctionResp.Summary == 1) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        this.userMessages = [];
      }

      if (completeFunctionResp.Summary == 2) {
        this.router.navigate(["/home"]);
        this.userMessages = [];
      }
    },
      (err) => {
        if (err.error && err.error.UserMessages != undefined) {
          err.error.UserMessages.forEach(element => {
            this.userMessages.push(element)
          });
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.currentPageWatcher.sendUserMessages(this.userMessages);
          this.spinner.hide();
        }
        else {
          //Other errors not in UserMessages

        }
      });

    }

  }

  returnToSeverNotification() {
    this.router.navigate(['/severEmploymentNotification']).then(() => {
      this.startFunctionService.getNotifyStepInProgress().emit(false);
      this.currentPageWatcher.sendUserMessages(null);
      this.severEmploymentService.getNotifySeverEmploymentInformation().emit(this.employmentInfo);
    });

  }


  ngOnDestroy(): void {
    this.severemploymentAgreementSubsription.unsubscribe();
    this.severEmploymentInfoSubscription.unsubscribe();
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.returnToSeverNotification();
  }

}









  








// WEBPACK FOOTER //
// ./src/app/broker/sever-employment/sever-employment-review/sever-employment-review.component.ts